document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".content-rail").forEach(initRail);

  function initRail(section) {
    const track = section.querySelector(".content-rail__track");
    const leftBtn = section.querySelector(".content-rail__arrow--left");
    const rightBtn = section.querySelector(".content-rail__arrow--right");

    if (!track) return;

    const getCardWidth = () => {
      const card = track.querySelector(".content-rail__card");
      if (!card) return 0;
      const style = window.getComputedStyle(track);
      const gap = parseInt(style.gap || 0);
      return card.offsetWidth + gap;
    };

    const updateArrows = () => {
      if (!leftBtn || !rightBtn) return;

      const maxScroll = track.scrollWidth - track.clientWidth;

      leftBtn.style.display = track.scrollLeft <= 0 ? "none" : "flex";
      rightBtn.style.display = track.scrollLeft >= maxScroll - 2 ? "none" : "flex";
    };

    leftBtn?.addEventListener("click", () => {
      track.scrollBy({ left: -getCardWidth(), behavior: "smooth" });
    });

    rightBtn?.addEventListener("click", () => {
      track.scrollBy({ left: getCardWidth(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    updateArrows();
  }
});